import { render, staticRenderFns } from "./pAbout.vue?vue&type=template&id=a5409370&scoped=true"
import script from "./pAbout.vue?vue&type=script&lang=js"
export * from "./pAbout.vue?vue&type=script&lang=js"
import style0 from "./pAbout.vue?vue&type=style&index=0&id=a5409370&prod&lang=scss&scoped=true"
import style1 from "./pAbout.vue?vue&type=style&index=1&id=a5409370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5409370",
  null
  
)

export default component.exports